import { apiRequest } from "./api";

/**
 * Fetch the paginated and filtered list of admin notifications.
 *
 * @param {Object}      [params]
 * @param {number}      [params.page=1]        - Page number (min 1)
 * @param {number}      [params.limit=20]      - Items per page (1-100)
 * @param {string|null} [params.type]          - e.g. "reviewer" | null = all
 * @returns {Promise<Object>} The API payload data containing items and pagination
 */
export async function fetchNotifications({
  page = 1,
  limit = 20,
  type = null,
} = {}) {
  const qs = new URLSearchParams();
  qs.set("page", page);
  qs.set("limit", limit);
  if (type) {
    qs.set("type", type);
  }

  const result = await apiRequest(`/admin/notifications?${qs.toString()}`);
  return result.data;
}

/**
 * Mark notifications as read in the backend.
 * Endpoint: POST /admin/notifications/mine/read
 *
 * @param {Object} payload
 * @param {string[]} payload.notification_ids
 * @param {boolean} payload.all
 * @returns {Promise<any>}
 */
export async function markNotificationsRead({ notification_ids = [], all = false }) {
  return apiRequest(`/admin/notifications/mine/read`, {
    method: "POST",
    body: JSON.stringify({
      notification_ids,
      all,
    }),
  });
}
